import API from "../../apiService";
import React, { useEffect, useRef, useState } from "react";
import moment from "moment/moment";
import ReactPaginate from "react-paginate";
import HistoryPregnant from "./HistoryPregnant";
import HistoryPregnantVisit from "./HistoryPregnantVisit";
import HistoryGigi from "./HistoryGigi";
import HistoryImmunization from "./HistoryImmunization";
import HistoryImmunizationRecord from "./HistoryImmunizationRecord";
import BlobPrint from "../component/BlobPrint";
import PrintButton from "../pendaftaran/module/PrintButton";
import LabPrint from "../lab/LabPrint";
import ReactToPrint from "react-to-print";

const HistoryGroup = ({ detilPx, history }) => {
  const [histories, setHistories] = useState([]);
  const [detailHistory, setDetailHistory] = useState([]);

  const [datas, setDatas] = useState([]);
  const [kajian, setKajian] = useState(null);

  useEffect(() => {
    getHistories();
    fetchKajian();
  }, []);

  const fetchKajian = async () => {
    let res = await API.get(
      `management/kajian_awal/result_patient/${detilPx.id}/dokter`
    );
    if (res) {
      setKajian(res.data.find((e) => e.name === "ANAMNESIS (S)"));
    }
  };

  const group = (data) => {
    let h = [];
    data.forEach((v) => {
      let f = h.find(
        (x) => x.date.split(" ")[0] === v.created_at.split(" ")[0]
      );
      if (f) {
        f.data.push(v);
      } else {
        h.push({
          date: v.created_at,
          data: [v],
        });
      }
    });
    return h.map((v) => {
      v.data = v.data.sort(function (a, b) {
        let keyA = new Date(a.created_at),
          keyB = new Date(b.created_at);
        if (keyA < keyB) return -1;
        if (keyA > keyB) return 1;
        return 0;
      });
      return v;
    });
  };

  const getHistories = async () => {
    const res = await API.get(
      "registration/history/" + detilPx.patients.id + "?grouped=1"
    );
    if (res.code === 200) {
      setHistories(res.data.data);
      setDatas(res.data.data);
    }
  };

  const onReload = () => {
    history.push("/pelayanan");
  };

  const changePage = async (e) => {
    const res = await API.get(
      "registration/history/" + detilPx.patients.id + "?grouped=1&page=" + e
    );
    if (res.code === 200) {
      setHistories(res.data.data);
      setDatas(res.data.data);
    }
  };

  const getHistoryDetail = async (history) => {
    let check = detailHistory.find((a) => a.date == history.date);
    if (!check) {
      const res = await API.get(
        "registration/history/detail/" +
          detilPx.patients.id +
          "/" +
          history.date
      );
      if (res.code === 200) {
        setDetailHistory([
          ...detailHistory,
          { date: history.date, data: res.data },
        ]);
      }
    }
  };

  useEffect(() => {
    console.log(detailHistory);
  }, [detailHistory.length]);

  return (
    <div>
      <div className="card">
        <div className="card-header">
          <h3>Histori Pelayanan</h3>
        </div>
        <div className="card-body">
          <div className="accordion" id="accordionRiwo">
            {histories.map((history, key) => (
              <div className="card" key={key}>
                <div
                  className="card-header"
                  id={"headingRiwo" + key}
                  data-toggle="collapse"
                  data-target={"#collapseRiwo" + key}
                  aria-expanded="false"
                  aria-controls={"collapseRiwo" + key}
                  onClick={(e) => getHistoryDetail(history)}
                >
                  <mark>
                    <em>
                      {moment(history.data[0].created_at).format("DD-MM-YYYY")}
                    </em>
                  </mark>
                  <div style={{ height: 8 }} />
                  {history.data.map((v, k) => (
                    <div className="text-primary h4 my-0" key={`clinic-${k}`}>
                      POLIKLINIK {v.clinics?.name?.toUpperCase() ?? "-"}
                      <span className={"ml-2"}>
                        {v.paramedic ? `[Dokter: ${v.paramedic.name}]` : ""}
                      </span>
                      <span className={"ml-2"}>
                        {v.nurse ? `[Perawat: ${v.nurse.name}]` : ""}
                      </span>
                    </div>
                  ))}
                </div>
                <div
                  id={"collapseRiwo" + key}
                  className="collapse"
                  aria-labelledby={"headingRiwo" + key}
                >
                  <div className="card-body">
                    <div className={"table-responsive"}>
                      <SOAP history={history} kajian={kajian} detailHistory={detailHistory} />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div
            className="dataTables_paginate paging_simple_numbers"
            id="datatable-buttons_paginate"
          >
            <ReactPaginate
              previousLabel={"<"}
              previousClassName={"paginate_button page-item previous"}
              previousLinkClassName={"page-link"}
              nextLabel={">"}
              nextClassName={"paginate_button page-item  next"}
              nextLinkClassName={"page-link"}
              breakLabel={"..."}
              pageClassName={"paginate_button page-item"}
              pageLinkClassName={"page-link"}
              pageCount={datas.last_page}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={(e) => changePage(e.selected + 1)}
              containerClassName={"pagination"}
              activeClassName={"active"}
            />
          </div>
        </div>

        <div className="card-footer">
          <button className="btn btn-danger" onClick={onReload}>
            Tutup
          </button>
        </div>
      </div>
    </div>
  );
};

export default HistoryGroup;

const SOAP = ({ history, kajian, detailHistory }) => {
  return (
    <table className="table table-bordered">
      <tbody>
        <tr>
          <th style={{ padding: "12px", width: 200, textAlign: "center" }}></th>
          {history.data.map((v) => (
            <th style={{ padding: "12px", textAlign: "center" }}>
              <div className={"text-muted"} style={{ fontSize: 12 }}>
                {moment(v.created_at).format("DD-MM-YYYY HH:mm:ss")}
              </div>
              <div className={"h4 text-black mb-0"}>
                POLIKLINIK {v.clinics?.name?.toUpperCase() ?? "-"}
              </div>
              {(v.paramedic || v.nurse) && (
                <div>
                  {v.paramedic ? `Dokter: ${v.paramedic.name}` : ""}
                  {v.paramedic && v.nurse && "  |  "}
                  {v.nurse ? `Perawat: ${v.nurse.name}` : ""}
                </div>
              )}
            </th>
          ))}
        </tr>
        <tr>
          <th style={{ padding: "12px", width: 200, textAlign: "center" }}></th>
          {history.data.map(() => (
            <th style={{ padding: "12px" }} className={"bg-secondary"}>
              <div className="text-black text-center h4">PELAYANAN UTAMA</div>
            </th>
          ))}
        </tr>
        <tr style={{ height: 1 }}>
          <th style={{ padding: "12px", width: 200, textAlign: "center" }}>
            {" "}
            SUBJECTIVE{" "}
          </th>
          {detailHistory.find((a) => a.date == history.date) &&
            detailHistory.find((a) => a.date == history.date).data.map((v) => (
              <td className={"p-0"} style={{ height: "inherit" }}>
                <Subjective history={v} kajian={kajian} />
              </td>
            ))}
        </tr>
        <tr style={{ height: 1 }}>
          <th style={{ padding: "12px", width: 200, textAlign: "center" }}>
            {" "}
            OBJECTIVE{" "}
          </th>
          {detailHistory.find((a) => a.date == history.date) &&
            detailHistory.find((a) => a.date == history.date).data.map((v) => (
              <td className={"p-0"} style={{ height: "inherit" }}>
                <Objective history={v} />
              </td>
            ))}
        </tr>
        <tr style={{ height: 1 }}>
          <th style={{ padding: "12px", width: 200, textAlign: "center" }}>
            {" "}
            ASSESMENT{" "}
          </th>
          {detailHistory.find((a) => a.date == history.date) &&
            detailHistory.find((a) => a.date == history.date).data.map((v) => (
              <td className={"p-0"} style={{ height: "inherit" }}>
                <Assessment history={v} />
              </td>
            ))}
        </tr>
        <tr style={{ height: 1 }}>
          <th style={{ padding: "12px", width: 200, textAlign: "center" }}>
            {" "}
            PLANNING{" "}
          </th>
          {detailHistory.find((a) => a.date == history.date) &&
            detailHistory.find((a) => a.date == history.date).data.map((v) => (
              <td className={"p-0"} style={{ height: "inherit" }}>
                <Planning history={v} />
              </td>
            ))}
        </tr>
        <tr style={{ height: 1 }}>
          <th style={{ padding: "12px", width: 200, textAlign: "center" }}></th>
          {detailHistory.find((a) => a.date == history.date) &&
            detailHistory.find((a) => a.date == history.date).data.map((v) => (
              <td className={"p-0 bg-secondary"} style={{ height: "inherit" }}>
                <Penunjang history={v} />
              </td>
            ))}
        </tr>
        <tr style={{ height: 1 }}>
          <th style={{ padding: "12px", width: 200, textAlign: "center" }}></th>
          {detailHistory.find((a) => a.date == history.date) &&
            detailHistory.find((a) => a.date == history.date).data.map((v) => (
            <td className={"p-2"} style={{ height: "inherit" }}>
              <button
                className="btn btn-success btn-sm mt-1"
                onClick={() => BlobPrint(`registration/history/soap/${v.id}/1`)}
              >
                Cetak Resume Medis
              </button>
              {v.clinic_id === 57 && (
                <PrintButton
                  url={`/registration/print/imunisasi/${v.id}`}
                  color="success"
                  buttonText={"Cetak Imunisasi"}
                />
              )}
            </td>
          ))}
        </tr>
      </tbody>
    </table>
  );
};

const Subjective = ({ history, kajian }) => {
  const [caten, setCaten] = useState(null);

  useEffect(() => {
    getCaten();
  }, []);

  const getCaten = async () => {
    if (history.clinics?.id === 51) {
      const res = await API.get(`registration/caten/read/${history.id ?? 0}`);
      if (res.code === 200 && res.data.length) {
        setCaten(res.data[0]);
      }
    }
  };

  return (
    <div className={"history-container"}>
      <div className={"history-data"}>
        <span className={"history-key"}>Anamnese Dokter</span>
        <span className={"history-value"}>
          <b>Keluhan Utama:</b>
          <br />
          {history.anamneses.length > 0 ? history.anamneses[0].anamnese : ""}
          <br />
          <b>Riwayat Penyakit Sekarang:</b>
          <br />
          {history.anamneses.length > 0 ? history.anamneses[0].rps : ""}
          <br />
          <b>Riwayat Penyakit Dahulu:</b>
          <br />
          {kajian?.ref_kajian[1]?.list[0]?.result?.result ?? ""}
          <br />
          <b>Riwayat Penyakit Keluarga:{history.clinics?.id}</b>
          <br />
          {kajian?.ref_kajian[2]?.list[0]?.result?.result ?? ""}
          <br />
          {history.clinics?.name?.toLowerCase()?.includes("psikolog") && (
            <>
              <b>Wawancara:</b>
              <br />
              {history.anamneses.length > 0
                ? history.anamneses[0].wawancara
                : ""}
              <br />
              <b>Observasi:</b>
              <br />
              {history.anamneses.length > 0
                ? history.anamneses[0].observasi
                : ""}
              <br />
            </>
          )}
          {(history.clinics?.id === 1 ||
            history.clinics?.id === 2 ||
            history.clinics?.parent_id === 5) && (
            <>
              <b>Obat Yang Dikonsumsi (Rekonsiliasi Obat):</b>
              <br />
              {history.anamneses[0] &&
                history.anamneses[0].rekonsiliasi_obat &&
                JSON.parse(history.anamneses[0].rekonsiliasi_obat)?.map(
                  (v, k) => (
                    <div key={`eaea-${k}`}>
                      {v.name}: {v.signa1}x{v.signa2}
                    </div>
                  )
                )}
              <br />
            </>
          )}
          {caten && (
            <>
              <b>Rencana Menikah:</b>
              <br />
              {caten.wedding_plan ?? ""}
              <br />
              <b>Perkawinan ke:</b>
              <br />
              {caten.wedding_number ?? ""}
              <br />
              <b>Haid Terakhir:</b>
              <br />
              {caten.last_menstruation ?? ""}
              <br />
              <b>Diberikan Imunisasi TT:</b>
              <br />
              {caten.given_tt_immunization ? "YA" : "TIDAK"}
              <br />
              <b>Imunisasi TT ke:</b>
              <br />
              {caten.tt_immunization_number ?? ""}
              <br />
              <b>Diberikan Screening TT:</b>
              <br />
              {caten.given_tt_screening ? "YA" : "TIDAK"}
              <br />
              <b>Screening ke:</b>
              <br />
              {caten.screening_number ?? ""}
              <br />
            </>
          )}
        </span>
      </div>
      <div className={"history-data"}>
        <span className={"history-key"}>Anamnese Perawat</span>
        <span className={"history-value"}>
          {history.anamneses.length > 0
            ? history.anamneses[0].nursing_anamnese
            : ""}
        </span>
      </div>
    </div>
  );
};

const Objective = ({ history }) => {
  const [caten, setCaten] = useState(null);

  useEffect(() => {
    getCaten();
  }, []);

  const getCaten = async () => {
    if (history.clinics?.id === 51) {
      const res = await API.get(`registration/caten/read/${history.id ?? 0}`);
      if (res.code === 200 && res.data.length) {
        setCaten(res.data[0]);
      }
    }
  };

  return (
    <div className={"history-container"}>
      <div className={"history-data"}>
        <span className={"history-key"}>Physic</span>
        <span className={"history-value"}>
          {" "}
          Berat badan :{" "}
          {history.examinations[0] ? history.examinations[0].weight : ""} <br />
          Tinggi Badan :{" "}
          {history.examinations[0] ? history.examinations[0].height : ""}
        </span>
      </div>
      <div className={"history-data"}>
        <span className={"history-key"}>Vital Sign</span>
        <span className={"history-value"}>
          Tekanan darah :{" "}
          {history.examinations[0] ? history.examinations[0].sistole : ""} /{" "}
          {history.examinations[0] ? history.examinations[0].diastole : ""}{" "}
          <br />
          Suhu :{" "}
          {history.examinations[0]
            ? history.examinations[0].temperature
            : ""}{" "}
          <br />
          VA Score :{" "}
          {history.examinations[0] ? history.examinations[0].va_score : ""}{" "}
          <br />
          SpO2 : {history.examinations[0]
            ? history.examinations[0].spo2
            : ""}{" "}
          <br />
          Nadi : {history.examinations[0]
            ? history.examinations[0].pulse
            : ""}{" "}
          <br />
          Pernafasan :{" "}
          {history.examinations[0]
            ? history.examinations[0].respiration
            : ""}{" "}
          <br />
          Golongan Darah :{" "}
          {history.examinations[0]
            ? history.examinations[0].blood !== null
              ? history.examinations[0].blood.name
              : ""
            : ""}
          {history.clinic_id === 51 && (
            <span>
              <br />
              Lila : {history.catens?.length ? history.catens[0].lila : ""}
            </span>
          )}
        </span>
      </div>
      <div className={"history-data"}>
        <span className={"history-key"}>Pemeriksaan Fisik</span>
        <span className={"history-value"}>
          Keadaan umum : <br />
          <br />
          Kepala :{" "}
          {history.examinations[0] ? history.examinations[0].kepala : ""} <br />
          Leher : {history.examinations[0]
            ? history.examinations[0].leher
            : ""}{" "}
          <br />
          Dada : {history.examinations[0]
            ? history.examinations[0].dada
            : ""}{" "}
          <br />
          Perut : {history.examinations[0]
            ? history.examinations[0].perut
            : ""}{" "}
          <br />
          Alat Gerak :{" "}
          {history.examinations[0] ? history.examinations[0].ex_bawah : ""}
          <br />
          Lainnya :
          {history.examinations[0]
            ? history.examinations[0].physic_anamnese
            : ""}
        </span>
      </div>
      {history.clinics?.name?.toLowerCase() === "gizi" && (
        <ObjectiveGizi history={history} />
      )}
      {history.clinic_id === 2 && (
        <div className={"history-data"} style={{ width: 600 }}>
          <div className={"history-value"}>
            <HistoryGigi visit={history} />
          </div>
        </div>
      )}
      {history.clinic_id === 53 && (
        <div className={"history-data"} style={{ width: 600 }}>
          <div className={"history-value"} style={{ width: 600 }}>
            <HistoryPregnant visit={history} />
            <HistoryPregnantVisit visit={history} />
          </div>
        </div>
      )}
      {history.clinic_id === 57 && (
        <div className={"history-data"} style={{ width: 600 }}>
          <div className={"history-value"} style={{ width: 600 }}>
            <HistoryImmunization visit={history} />
            <HistoryImmunizationRecord visit={history} />
          </div>
        </div>
      )}
      {history.clinic_id === 51 && (
        <div className={"history-data"} style={{ width: 600 }}>
          <span className={"history-key"}>Tahun Perkawinan</span>
          <div className={"history-value"} style={{ width: 600 }}>
            {caten?.year_of_marriage ?? ""}
          </div>
        </div>
      )}
    </div>
  );
};

const ObjectiveGizi = ({ history }) => {
  const [show, setShow] = useState(false);

  return (
    <div className={"history-data"}>
      <span className={"history-key"}>Objective Gizi</span>
      <div className={"history-value"}>
        {show && (
          <div className={"mb-2"}>
            <h4 className={"mb-0"}>A. Antropometri</h4>
            <b>BB/U :</b> {history.nutrition_transaction?.bbu ?? ""}
            <br />
            <b>TB/U :</b> {history.nutrition_transaction?.tbu ?? ""}
            <br />
            <b>BB/TB :</b> {history.nutrition_transaction?.bb_tb ?? ""}
            <br />
            <b>Lila :</b> {history.nutrition_transaction?.lila ?? ""} cm
            <br />
            <b>RL :</b> {history.nutrition_transaction?.rl ?? ""} cm
            <br />
            <b>Estimasi TB :</b>{" "}
            {history.nutrition_transaction?.estimasi_tb ?? ""} cm
            <br />
            <b>Estimasi BBI :</b>{" "}
            {history.nutrition_transaction?.estimasi_bbi ?? ""} cm
            <br />
            <b>Kesimpulan Status Gizi :</b>{" "}
            {history.nutrition_transaction?.kesimpulan ?? ""}
            <br />
            <br />
            <h4 className={"mb-0"}>B. Biokimia</h4>
            <b>Kesimpulan Biokimia :</b>{" "}
            {history.nutrition_transaction?.kesimpulan_bio ?? ""}
            <br />
            <br />
            <h4 className={"mb-0"}>C. Clinik/Fisik</h4>
            <b>Gangguan GIT :</b> {history.nutrition_transaction?.git ?? ""}
            <br />
            <b>Gangguan GIT Lainnya :</b>{" "}
            {history.nutrition_transaction?.other_git ?? ""}
            <br />
            <b>Pemeriksaan Penunjang :</b>{" "}
            {history.nutrition_transaction?.pemeriksaan_penunjang ?? ""}
            <br />
            <b>Kesimpulan Clinic/Fisik :</b>{" "}
            {history.nutrition_transaction?.kesimpulan_fisik ?? ""}
            <br />
            <br />
            <h4 className={"mb-0"}>D. Dietary History </h4>
            <b>Alergi Makanan :</b>{" "}
            {history.nutrition_transaction?.is_alergi_makanan
              ? `Ya: ${history.nutrition_transaction?.alergi_makanan ?? ""}`
              : "Tidak"}
            <br />
            <b>Pantangan Makanan :</b>{" "}
            {history.nutrition_transaction?.is_pantangan_makanan
              ? `Ya: ${history.nutrition_transaction?.pantangan_makanan ?? ""}`
              : "Tidak"}
            <br />
            <b>Diet yang dijalani :</b>{" "}
            {history.nutrition_transaction?.diet ?? ""}
            <br />
            <b>Pola Makan :</b>
            <br />
            <div className={"ml-4"}>
              <b>Nasi :</b> {history.nutrition_transaction?.nasi1 ?? ""} x{" "}
              {history.nutrition_transaction?.nasi2 ?? ""} ctg/hr
            </div>
            <div className={"ml-4"}>
              <b>LH :</b> {history.nutrition_transaction?.lh1 ?? ""} x{" "}
              {history.nutrition_transaction?.lh2 ?? ""} pot/hr
            </div>
            <div className={"ml-4"}>
              <b>LN :</b> {history.nutrition_transaction?.ln1 ?? ""} x{" "}
              {history.nutrition_transaction?.ln2 ?? ""} pot/hr
            </div>
            <div className={"ml-4"}>
              <b>Sayur :</b> {history.nutrition_transaction?.sayur1 ?? ""} x{" "}
              {history.nutrition_transaction?.sayur2 ?? ""} mkk/hr
            </div>
            <div className={"ml-4"}>
              <b>Buah :</b> {history.nutrition_transaction?.buah1 ?? ""}{" "}
              {history.nutrition_transaction?.buah2 ?? ""}
            </div>
            <div className={"ml-4"}>
              <b>Selingan :</b> {history.nutrition_transaction?.selingan1 ?? ""}{" "}
              x {history.nutrition_transaction?.selingan2 ?? ""} /hr :{" "}
              {history.nutrition_transaction?.selingan3 ?? ""}
            </div>
            <b>Recal 24-Jam :</b>
            <br />
            <div className={"ml-4"}>
              <b>Karbohidrat :</b>{" "}
              {history.nutrition_transaction?.recal_carbohydrate ?? ""}
            </div>
            <div className={"ml-4"}>
              <b>Energi :</b>{" "}
              {history.nutrition_transaction?.recal_energy ?? ""}
            </div>
            <div className={"ml-4"}>
              <b>Protein :</b>{" "}
              {history.nutrition_transaction?.recal_protein ?? ""}
            </div>
            <div className={"ml-4"}>
              <b>Lemak :</b> {history.nutrition_transaction?.recal_fat ?? ""}
            </div>
          </div>
        )}
        <button
          className={"btn btn-success btn-sm"}
          onClick={() => setShow(!show)}
        >
          {show ? "Tutup" : "Lihat"}
        </button>
      </div>
    </div>
  );
};

const Assessment = ({ history }) => {
  return (
    <div className={"history-container"}>
      <div className={"history-data"}>
        <span className={"history-key"}>Diagnosa Dokter</span>
        <span className={"history-value"}>
          {history.clinics?.name === "Gizi"
            ? history.gizi_diagnoses.map((s, y) => {
                return (
                  <div key={y} style={{ color: s.log ? "red" : " " }}>
                    {s.icd_code} - {s.icd_name}
                  </div>
                );
              })
            : history.diagnoses.map((s, y) => {
                return (
                  <div key={y} style={{ color: s.log ? "red" : " " }}>
                    {s.icd_code} - {s.icd_name}
                  </div>
                );
              })}
        </span>
      </div>
      <div className={"history-data"}>
        <span className={"history-key"}>Diagnosa Naratif</span>
        <span className={"history-value"}>
          {history.examinations[0]
            ? history.examinations[0].diagnostic_narativ
            : ""}
        </span>
      </div>
      <div className={"history-data"}>
        <span className={"history-key"}>Diagnosa Keperawatan</span>
        <span className={"history-value"}>
          {history.nurse_diagnosis.length > 0
            ? history.nurse_diagnosis.map((s, y) => {
                return (
                  <div key={y} style={{ color: s.log ? "red" : " " }}>
                    {s.icd_code} - {s.nurse_code?.nurse_diagnosis}
                  </div>
                );
              })
            : ""}
        </span>
      </div>
    </div>
  );
};

const Planning = ({ history }) => {
  return (
    <div className={"history-container"}>
      {history.clinics?.name === "Gizi" && (
        <div className={"history-data"}>
          <span className={"history-key"}>Terapi</span>
          <span className={"history-value"}>
            <b>Jenis Diet : </b>
            {history.nutrition_transaction?.planing_diet_type ?? ""}
            <br />
            <b>Energi : </b>
            {history.nutrition_transaction?.planing_energy ?? ""}
            <br />
            <b>Karbohidrat : </b>
            {history.nutrition_transaction?.planing_carbohydrate ?? ""}
            <br />
            <b>Protein : </b>
            {history.nutrition_transaction?.planing_protein ?? ""}
            <br />
            <b>Lemak : </b>
            {history.nutrition_transaction?.planing_fat ?? ""}
          </span>
        </div>
      )}
      <div className={"history-data"}>
        <span className={"history-key"}>Tindakan</span>
        <span className={"history-value"}>
          {history.treatments.length > 0
            ? history.treatments.map((s, y) => {
                return (
                  <div
                    key={y}
                    style={{
                      color: s.log > 0 ? "red" : " ",
                    }}
                  >
                    {s.treatment.name} {s.log > 0 ? "(dihapus)" : " "}
                    <br />
                    catatan :{s?.note}{" "}
                  </div>
                );
              })
            : ""}
        </span>
      </div>
      {history.clinics?.name?.toLowerCase()?.includes("psikolog") && (
        <div className={"history-data"}>
          <span className={"history-key"}>Intervensi Psikolog</span>
          <span className={"history-value"}>
            {history.advice ? history.advice.intervensi_psikologis : ""}
          </span>
        </div>
      )}
      {!history.clinics?.name?.toLowerCase()?.includes("gizi") &&
        !history.clinics?.name?.toLowerCase()?.includes("psikolog") && (
          <div className={"history-data"}>
            <span className={"history-key"}>Pengobatan</span>
            <span className={"history-value"}>
              {history.prescribes.length > 0
                ? history.prescribes.map((s, y) => {
                    if (s.combination_name === "") {
                      return (
                        <div
                          key={y}
                          style={{
                            color: s.log > 0 ? "red" : " ",
                          }}
                        >
                          {s.details.length && !s.drug_taken_date
                            ? s.details[0]?.drug.name +
                              " (" +
                              s.details[0]?.qty +
                              ")" +
                              " (" +
                              s.signa.name +
                              ")"
                            : ""}
                          {s.details.length && s.drug_taken_date
                            ? s.details[0]?.drug.name +
                              " (" +
                              s.details
                                .filter((v) => v.accepted)
                                .map((v) => v.qty)
                                .reduce((a, b) => +a + +b, 0) +
                              ")" +
                              " (" +
                              s.signa.name +
                              ")"
                            : ""}
                          {s.details.length > 0
                            ? s.log > 0
                              ? "(dihapus)"
                              : " "
                            : " "}
                        </div>
                      );
                    } else {
                      let details = [];
                      s.details.forEach((v) => {
                        const i = details.findIndex(
                          (d) => d.drug.id === v.drug.id
                        );
                        if (i !== -1) details[i].qty += +v.qty;
                        else details.push({ ...v, qty: +v.qty });
                      });
                      return (
                        <div
                          key={y}
                          style={{
                            color: s.log > 0 ? "red" : " ",
                          }}
                        >
                          {"Nama Kombinasi : " +
                            s.combination_name +
                            " (" +
                            s.combination_qty +
                            ")" +
                            " (" +
                            s.signa.name +
                            ")"}
                          {s.log > 0 ? "(dihapus)" : " "}
                          {details.map((x, y) => {
                            return (
                              <div
                                style={{
                                  paddingLeft: "10px",
                                }}
                                key={y}
                              >
                                {"+ " + x.drug.name + " (" + x.qty + ")"}
                              </div>
                            );
                          })}
                        </div>
                      );
                    }
                  })
                : ""}
            </span>
          </div>
        )}
      <div className={"history-data"}>
        <span className={"history-key"}>Saran</span>
        <span className={"history-value"}>
          {history.advice ? history.advice.advice : ""}
        </span>
      </div>
      <div className={"history-data"}>
        <span className={"history-key"}>Evaluasi</span>
        <span className={"history-value"}>
          {history.advice ? history.advice.evaluation : ""}
        </span>
      </div>
      <div className={"history-data"}>
        <span className={"history-key"}>Tindakan Keperawatan</span>
        <span className={"history-value"}>
          {history.anamneses.length > 0 ? history.anamneses[0].treat : ""}
        </span>
      </div>
      <div className={"history-data"}>
        <span className={"history-key"}>Evaluasi Keperawatan</span>
        <span className={"history-value"}>
          {history.anamneses.length > 0 ? history.anamneses[0].eval : ""}
        </span>
      </div>
    </div>
  );
};

const Penunjang = ({ history }) => {
  const [samples, setSamples] = useState([]);
  const [profile, setProfile] = useState({ villages: null });
  const [theLab, setTheLab] = useState([]);
  const ref = useRef(null);

  useEffect(() => {
    if (history.labs.length) {
      getRefLabSamples();
      getProfile();
      getLabGroup();
    }
  }, []);

  const getProfile = async () => {
    setProfile(await GetProfile());
  };

  const getLabGroup = async () => {
    const lg = await GetLabGroup();
    let group = [];
    let lab = [];
    let d = 0;
    lg.data.map((x, n) => {
      group[n] = x;

      x.details.map((detail) => {
        lab[d] = detail;
        let h = history.labs[0].details.find(
          (set) => !set.log && set.lab_id === detail.lab_id
        );
        if (h) {
          lab[d].registration_id = h.id;
          lab[d].result = h.result;
          lab[d].checked = true;
          lab[d].hidden = false;
          lab[d].isDisabled = true;
          lab[d].user = h.user.name;
          lab[d].date = h.updated_at;
        } else {
          lab[d].registration_id = null;
          lab[d].result = "";
          lab[d].checked = false;
          lab[d].hidden = true;
          lab[d].isDisabled = false;
          lab[d].user = "-";
          lab[d].date = "";
        }
        lab[d].value = detail.lab ? detail.lab.id : "";
        lab[d].label = detail.lab ? x.name + " | " + detail.lab.name : "";

        lab[d].group_id = x.id;
        d++;
      });
    });

    setTheLab(group);
  };

  const getRefLabSamples = async () => {
    var res4 = await API.get(
      "management/lab_category/search/" + history.labs[0].sample
    );
    let fs = [];
    if (res4.code === 200) {
      res4.data.map((x, k) => {
        fs[k] = x.name;
      });

      setSamples(fs);
    }
  };

  return (
    <div>
      <table className="table" style={{ background: "white" }}>
        <tbody>
          <tr className="bg-secondary">
            <th style={{ padding: "12Px", border: "none" }} colSpan={2}>
              <div className="text-black text-center h4 mb-0">
                PELAYANAN PENUNJANG
              </div>
            </th>
          </tr>
          {history.labs[0] ? (
            history.labs[0].details
              .filter((v) => !v.log)
              .map((s, k) => {
                return (
                  <tr key={k}>
                    <th
                      style={{
                        padding: "12Px",
                        borderLeft: "none",
                        borderBottom: "none",
                      }}
                    >
                      Pemeriksaan {s.lab?.category?.name} | {s.lab?.name}
                    </th>
                    <td
                      style={{
                        padding: "12Px",
                        borderRight: "none",
                        borderBottom: "none",
                      }}
                    >
                      {s.result + " " + s.lab.unit}
                    </td>
                  </tr>
                );
              })
          ) : (
            <tr>
              <td
                className="text-center"
                colSpan={2}
                style={{
                  padding: "12Px",
                  borderLeft: "none",
                  borderRight: "none",
                  borderBottom: "none",
                }}
              >
                Data tidak ditemukan
              </td>
            </tr>
          )}
          {history.labs[0] && (
            <tr>
              <td className="text-center" colSpan={2}>
                <ReactToPrint
                  trigger={() => (
                    <a href="#">
                      <button className="btn btn-success btn-sm" type="button">
                        Cetak Hasil Lab
                      </button>
                    </a>
                  )}
                  copyStyles={false}
                  content={() => ref.current}
                />
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <div style={{ display: "none" }}>
        {history.labs.length && (
          <LabPrint
            ref={ref}
            detilPx={history}
            labs={history.labs[0].details}
            lab={theLab}
            samples={samples}
            user={history.labs[0].user}
            profile={profile}
            registration_lab={history.labs[0]}
          />
        )}
      </div>
    </div>
  );
};

let profile = null;
const GetProfile = async () => {
  if (profile) {
    return profile;
  }

  const dod = await API.get(
    "management/profiles/read?code=" +
      JSON.parse(localStorage.getItem("userData")).puskesmas_id
  );
  if (dod.code === 200) {
    profile = dod.data;
  }
  return profile;
};

let labGroup = null;
const GetLabGroup = async () => {
  if (labGroup) {
    return labGroup;
  }

  var res2 = await API.get("management/lab_group/read");
  if (res2.code === 200) {
    labGroup = res2;
  }
  return labGroup;
};
